import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "comum-group" */ "../views/Index.vue"),
    children: [
      {
        path: "",
        name: "index",
        redirect: { name: "buscar-estudos" }
      },
      // {
      //   path: "visaoGeral",
      //   name: "visao-geral",
      //   component: VisaoGeral
      // },
      {
        path: "buscarEstudos",
        name: "buscar-estudos",
        component: () =>
          import(
            /* webpackChunkName: "search-group" */ "../views/BuscarEstudo.vue"
          )
      },
      {
        path: "lixeira",
        name: "lixeira",
        component: () =>
            import(
                /* webpackChunkName: "search-group" */ "../views/Lixeira.vue"
                )
      },
      {
        path: "administrativo",
        component: () =>
          import(
            /* webpackChunkName: "adm-group" */ "../views/Administrativo.vue"
          ),
        children: [
          {
            path: "",
            name: "administrativo",
            redirect: { name: "dispositivos" },
            meta: {
              esconderRodape: true,
              menuAtivo: "menu-servidor"
            }
          },
          {
            path: "dispositivos",
            name: "dispositivos",
            component: () =>
              import(
                /* webpackChunkName: "adm-group" */ "../views/Dispositivos.vue"
              ),
            meta: {
              esconderRodape: true,
              menuAtivo: "menu-dispositivos"
            }
          },
          {
            path: "armazenamentos",
            name: "armazenamentos",
            component: () =>
                import(
                    /* webpackChunkName: "adm-group" */ "../views/Armazenamentos.vue"
                    ),
            meta: {
              esconderRodape: true,
              menuAtivo: "menu-armazenamentos"
            }
          },
          {
            path: "licencas",
            name: "licencas",
            component: () =>
              import(
                /* webpackChunkName: "adm-group" */ "../views/Licencas.vue"
              ),
            meta: {
              esconderRodape: true,
              menuAtivo: "menu-licenca",
              superUsuario: true
            }
          }
        ]
      }
    ]
  },
  {
    path: "/autenticacao",
    name: "autenticacao",
    component: () =>
      import(/* webpackChunkName: "auth-group" */ "../views/Autenticacao.vue"),
    meta: { acessoPublico: true }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.acessoPublico)) {
    next();
  } else if (localStorage.getItem("manager_token") == null) {
    next({ path: "/autenticacao", proximaUrl: to.fullPath });
  } else {
    next();
  }
});

export default router;
